module.exports = __webpack_public_path__ + "img/Stat_close_combat.2aec86d8.png";